module.exports = __webpack_public_path__ + "static/media/non-responsive-calls.33bba0de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/non-responsive-calls.svg
// module id = 878
// module chunks = 0